import { Container, Row, Col } from "react-bootstrap";

const Informations = () => {
  return (
    <Row className="desktop-flex informations-container">
      <Col lg={1}>
        <hr className="separateur-contact"></hr>
      </Col>
      <Col lg={10}>
        <Row>
          <Col lg={12} className="mb-5">
            <b className="adresse-1-place-de-container">
              <p className="adresse">
                <span>
                  <span className="contact-sstitre">ADRESSE</span>
                </span>
              </p>
              <a href="https://www.google.com/maps/place/58+Cor+Fleurie,+06200+Nice/@43.6833328,7.2086909,17z/data=!3m1!4b1!4m6!3m5!1s0x12cdd1a5f8cf6e39:0xd784251160ead840!8m2!3d43.6833289!4d7.2112658!16s%2Fg%2F11c4vs4zrk?entry=ttu&g_ep=EgoyMDI1MDQyNy4xIKXMDSoASAFQAw%3D%3D">
                <span className="nous-vous-remercions">
                  <span className="place-de-lglise1">
                    58 corniche fleurie 06200 Nice
                  </span>
                </span>
                {/* <span className="nous-vous-remercions">
                  <span className="place-de-lglise1"></span>
                </span> */}
              </a>
            </b>
          </Col>
          <Col lg={12} className="mb-5">
            <b className="support-t-33-container">
              <p className="adresse">
                <span>
                  <span className="contact-sstitre">SUPPORT</span>
                </span>
              </p>
              {/* <a href="tel:+33142120317"><span className="nous-vous-remercions">+33 (0)1 42 12 03 17</span></a> */}
              <a href="tel:+330492136354">
                <span className="nous-vous-remercions">
                  T / 04 92 13 63 54
                  <br />
                </span>
              </a>
              <a href="mailto:direction@up4mind.com">
                <span className="nous-vous-remercions">
                  E / DIRECTION@UP4MIND.COM
                </span>
              </a>
            </b>
          </Col>
          <Col lg={12} className="mb-5">
            <b className="ouverture-lundi-vendredi-10-container">
              <p className="adresse">
                <span>
                  <span className="contact-sstitre">OUVERTURE</span>
                </span>
              </p>
              <p className="adresse">
                <span>LUNDI / VENDREDI</span>
                <p className="adresse">9H00 - 18H00</p>
              </p>
            </b>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Informations;
